// ROO-203 / ROO-204: hero imagery for the learning-resources articles.
//
// Real professional stock photos (Pexels — free for commercial use; provenance
// in src/assets/articles/CREDITS.txt), optimised to WebP and BUNDLED with the
// app, so they are served from our own origin — no external image URLs that can
// 404. Every `<slug>.webp` in src/assets/articles is picked up automatically by
// slug (via webpack require.context), so adding an image is just dropping a file
// named after the article's slug — no code change here.

interface Theme { accent: string; soft: string; }

// One accent colour per category, used for the article's category label.
const THEMES: Record<string, Theme> = {
  'Reading & Comprehension':   { accent: '#14593C', soft: '#DDEFE4' },
  'Writing':                   { accent: '#D65A38', soft: '#FBE0D6' },
  'Mathematical Reasoning':    { accent: '#7C2BB8', soft: '#EFE0F8' },
  'Thinking Skills':           { accent: '#E0761A', soft: '#FCE7CC' },
  'Exam Strategy & Wellbeing': { accent: '#2F6DB5', soft: '#DCEAF7' },
  'Vocabulary & Language':     { accent: '#0F766E', soft: '#D5EEEA' },
  'About the Tests':           { accent: '#B4530A', soft: '#F7E4D0' },
};

const FALLBACK: Theme = { accent: '#5C6A72', soft: '#E7EBED' };

export function categoryTheme(category: string | null | undefined): Theme {
  return (category && THEMES[category]) || FALLBACK;
}

// Bundle every <slug>.webp in src/assets/articles, keyed by slug.
/* eslint-disable @typescript-eslint/no-explicit-any */
const ctx = (require as any).context('../assets/articles', false, /\.webp$/);
const PHOTOS: Record<string, string> = {};
ctx.keys().forEach((k: string) => {
  const slug = k.replace(/^\.\//, '').replace(/\.webp$/, '');
  PHOTOS[slug] = ctx(k);
});
/* eslint-enable @typescript-eslint/no-explicit-any */

/** The bundled hero image URL for an article, or null if we don't ship one. */
export function articleImage(slug: string | null | undefined): string | null {
  return (slug && PHOTOS[slug]) || null;
}

/** True when we ship a hero image for this slug (so callers can skip the banner
 *  for unknown/legacy slugs rather than render an empty one). */
export function articleHasArt(slug: string | null | undefined): boolean {
  return !!slug && slug in PHOTOS;
}
